<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindowSA">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["TNMT"][obj_Tournament.I > 0? "ETNMT": "ATNMT"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>1</span>{{this.getLanguage["TNMT"]["TNMTI"]}}</h6>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="3">
                                            <label class="col-form-label-sm">{{this.getLanguage["TNMT"]["IAGI"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="true"
                                                              :options="dd_agentgroup"
                                                              :defaultExpandLevel="Infinity"
                                                              valueConsistsOf="LEAF_PRIORITY"
                                                              :disable-branch-nodes="false"
                                                              :clearable="true"
                                                              :placeholder="getLanguage['GL']['ALL']"
                                                              :limit="1"
                                                              :limitText="count => `+${count}`"
                                                              v-model="obj_Tournament.AGIT"
                                                              @input="AgentGroupChange" />
                                        </CCol>
                                        <CCol col="3">
                                            <label class="col-form-label-sm">{{this.getLanguage["TNMT"]["TN"]}}<span class="required" /> :</label>
                                            <CInput :placeholder="getLanguage['TNMT']['TN']" size="sm" :value="obj_Tournament.TN" @change="v => obj_Tournament.TN = v" ref="TN" :disabled="obj_Tournament.I > 0 && !obj_Tournament.enableEdit"></CInput>
                                            <span class="ErrMsg">{{ ValidationTournamentErrMsg('TN','TNMT','TN') }}</span>
                                        </CCol>
                                        <CCol col="2">
                                            <label class="col-form-label-sm">{{this.getLanguage["TNMT"]["CODE"]}}<span class="required" /> :</label>
                                            <span class="WCMsg" v-if="obj_Tournament.TDC != null">{{ this.obj_Tournament.TDC.length }} / 2 </span>
                                            <span class="WCMsg" v-else> 0 / 2 </span>
                                            <CInput maxlength="2" size="sm" :value="obj_Tournament.TDC" @change="v => obj_Tournament.TDC = v" />
                                            <span class="ErrMsg">{{ ValidationTournamentErrMsg('TDC','TNMT','CODE') }}</span>
                                        </CCol>
                                        <CCol col="2">
                                            <label class="col-form-label-sm">{{this.getLanguage["MSA"]["C"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_currency"
                                                        :placeholder="getLanguage['MSA']['C']"
                                                        :max-height="200"
                                                        v-model="obj_Tournament.CI"                                                        
                                                        @input="CurrencyChange"
                                                        :clearable="false"
                                                        ref="CI" />
                                            <span class="ErrMsg">{{ ValidationTournamentErrMsg('CI', 'MSA', 'C') }}</span>
                                        </CCol>
                                        <CCol col="2" class="text-right">
                                            <label class="col-form-label-sm" style="margin-right: 20px;">{{this.getLanguage["TNMT"]["ACT"]}} ?</label>
                                            <label class="switch">
                                                <input type="checkbox" true-value="2" false-value="1" v-model="obj_Tournament.RS" />
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                    </CRow>
                                    <CRow class="my-2" v-if="this.dd_language.length > 0">
                                        <CCol>
                                            <h6 @click="visible = !visible" class="card-title section-title2 pl-3 m-0">
                                                <template>
                                                    <template v-if="visible">
                                                        {{this.getLanguage["BTN"]["HD"]}}
                                                    </template>
                                                    <template v-else>
                                                        {{this.getLanguage["BTN"]["V"]}}
                                                    </template>
                                                    {{this.getLanguage["TNMT"]["TNMTMLS"]}}
                                                </template>
                                                <i class="chevron-container chevron-up" v-if="visible"></i>
                                                <i class="chevron-container" v-else></i>
                                            </h6>
                                            <div v-show="visible">
                                                <div class="row mx-0 my-3" id="webTempSetting">
                                                    <div class="col-md-2 px-0">
                                                        <div class="nav flex-column nav-pills tempScrollbar" aria-orientation="vertical" style="max-height: 584px; overflow: hidden scroll; padding: 0; flex-wrap: nowrap ">
                                                            <a class="" :class="(selectedLang == item.id)? 'nav-link active' : 'nav-link'" @click="selectedLang = item.id" v-for="(item, index) in dd_language" :key="index" style="border-radius: 0px; padding: 0.5rem 0.5rem; font-size: smaller;">
                                                                <div class="d-flex align-items-center">
                                                                    <span class="flagClass mr-2" :class="mapLanguageFlag(item.id)"></span>
                                                                    <span>{{ item.label }}</span>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-10 pr-0">
                                                        <div class="tab-content">
                                                            <div class="card tab-content p-2">
                                                                <div :class="item.id == selectedLang ? 'tab-pane fade active show': 'tab-pane fade'" :id="'lang-'+item.id" v-for="(item, index) in dd_language">
                                                                    <CCol col="12">
                                                                        <label class="col-form-label-sm font-weight-bold">{{ item.label }}</label>
                                                                    </CCol>
                                                                    <CCol col="4">
                                                                        <label class="col-form-label-sm">{{getLanguage["TNMT"]["TN"]}}:</label>
                                                                        <CInput :placeholder="getLanguage['TNMT']['TN']" size="sm" :value="array_tn[item.id]" v-model="array_tn[item.id]" ref="TN"></CInput>
                                                                    </CCol>
                                                                    <CCol col="12">
                                                                        <label class="col-form-label-sm">{{getLanguage['AFF']['R']}}:</label>
                                                                        <editor :id="'htmluuid-'+index" @onChange="HTMLEditorTextChange($event,item.id)" :value="array_tnc[item.id]" :init="init" />
                                                                    </CCol>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["TNMT"]["TIMURL"]}}<span class="required" /> :</label>
                                            <CTabs variant='tabs' id="imageURLTab">
                                                <CTab :title="getLanguage['CTAB']['SI']" :active="obj_Tournament.ISI == 1 ? true: false">
                                                    <div>
                                                        <label class="col-form-label-sm">{{this.getLanguage["CMS"]["GC"]}} :</label>
                                                        <treeselect :multiple="false"
                                                                    :clearable="false"
                                                                    :options="dd_gameCat"
                                                                    :placeholder="getLanguage['GL']['ALL']"
                                                                    :max-height="200"
                                                                    v-model="ISI_index"
                                                                    @input="GameCatChange(1, ISI_index)" />
                                                    </div>
                                                    <div class="tempScrollbar">
                                                        <div class="mr-2" v-for="tempB in dd_tournamentBackground" :key="tempB.id">
                                                            <div class="card text-center pointer" :class="(tempB.extra == obj_Tournament.TIURL) ? 'active' : ''" @click="TournamentImageChange(1, tempB.extra)">
                                                                <input type="radio" name="tournamentBackground" class="radio" :id="tempB.id" :value="tempB.id" :checked="(tempB.extra == obj_Tournament.TIURL)" />
                                                                <div style=" width: 130px; height: 80px; margin: auto;">
                                                                    <img class="card-img-top" :src="tempB.extra" style=" width: auto; height: 80px;max-width:100%">
                                                                </div>
                                                                <div class="card-body" style="border-top: 1px solid rgba(0,0,0,0.125); padding: 0.2rem;">
                                                                    <p class="mb-0" v-if="tempB.label.length >= 15"><marquee scrollamount="1">{{tempB.label}}</marquee></p>
                                                                    <p class="mb-0" v-else>{{tempB.label}}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CTab>
                                                <CTab :title="getLanguage['CTAB']['UI']" :active="obj_Tournament.ISI == 0 ? true: false">
                                                    <img v-if="obj_Tournament['I'] >= 0 && obj_Tournament.ISI == 0  && obj_Tournament.TIURL"
                                                         height="150"
                                                         width="100%"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_Tournament['TIURL'])" style="max-width:100%" />
                                                    <div class="custom-file">
                                                        <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onFileSelectedB" required>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-if="selectedFileB === null">{{ getLanguage['CTAB']['CAI'] }}.</label>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-else>{{selectedFileB.name}}</label>
                                                        <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                    </div>
                                                    <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 1920 x 500</label>
                                                </CTab>
                                            </CTabs>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["TNMT"]["TLIMURL"]}}<span class="required" /> :</label>
                                            <CTabs variant='tabs' id="imageURLTab">
                                                <CTab :title="getLanguage['CTAB']['SI']" :active="obj_Tournament.ISLI == 1 ? true: false">
                                                    <div>
                                                        <label class="col-form-label-sm">{{this.getLanguage["CMS"]["GC"]}} :</label>
                                                        <treeselect :multiple="false"
                                                                    :clearable="false"
                                                                    :options="dd_gameCat"
                                                                    :placeholder="getLanguage['GL']['ALL']"
                                                                    :max-height="200"
                                                                    v-model="ISLI_index"
                                                                    @input="GameCatChange(2, ISLI_index)" />
                                                    </div>
                                                    <div class="tempScrollbar">
                                                        <div class="mr-2" v-for="tempL in dd_tournamentLogo" :key="tempL.id">
                                                            <div class="card text-center pointer" :class="(tempL.extra == obj_Tournament.TLIURL) ? 'class' : ''" @click="TournamentImageChange(2, tempL.extra)">
                                                                <input type="radio" name="tournamentLogo" class="radio" :id="tempL.id" :value="tempL.id" :checked="(tempL.extra == obj_Tournament.TLIURL)" />
                                                                <div style=" width: 130px; height: 80px; margin: auto;">
                                                                    <img class="card-img-top" :src="tempL.extra" style=" width: auto; height: 80px;max-width:100%">
                                                                </div>
                                                                <div class="card-body" style="border-top: 1px solid rgba(0,0,0,0.125); padding: 0.2rem;">
                                                                    <p class="mb-0" v-if="tempL.label.length >= 15"><marquee scrollamount="1">{{tempL.label}}</marquee></p>
                                                                    <p class="mb-0" v-else>{{tempL.label}}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CTab>
                                                <CTab :title="getLanguage['CTAB']['UI']" :active="obj_Tournament.ISLI == 0 ? true: false">
                                                    <img v-if="obj_Tournament['I'] >= 0 && obj_Tournament.ISLI == 0 && obj_Tournament.TLIURL"
                                                         height="150"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_Tournament['TLIURL'])" style="max-width:100%" />
                                                    <div class="custom-file">
                                                        <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onFileSelectedL" required>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-if="selectedFileL === null">{{ getLanguage['CTAB']['CAI'] }}.</label>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-else>{{selectedFileL.name}}</label>
                                                        <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                    </div>
                                                    <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 400 x 500</label>
                                                </CTab>
                                            </CTabs>
                                        </CCol>

                                        <CCol col="12" v-if="obj_Tournament['I'] > 0 && obj_Tournament['TIURL'] && obj_Tournament['TLIURL']" >
                                            <label class="mandatory_Field pointer" @click="bool_isPreview = true">{{this.getLanguage["GL"]["PTD"]}}</label>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>2</span>{{this.getLanguage["TNMT"]["TNMTR"]}}</h6>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="3">
                                            <label class="col-form-label-sm">{{this.getLanguage["TNMT"]["PCT"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :clearable="false"
                                                        :options="dd_TournamentPointCalculationType"
                                                        :placeholder="getLanguage['TNMT']['PCT']"
                                                        :max-height="200"
                                                        v-model="obj_Tournament.PCT"
                                                        :disabled="obj_Tournament.I > 0 && !obj_Tournament.enableEdit"
                                                        ref="PCT" />
                                            <span class="ErrMsg">{{ ValidationTournamentErrMsg('PCT', 'TNMT', 'PCT') }}</span>
                                        </CCol>
                                        <CCol col="2">
                                            <label class="col-form-label-sm">{{this.getLanguage["TNMT"]["AP"]}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_TournamentPayoutOption"
                                                        :placeholder="getLanguage['PM']['DT']"
                                                        :max-height="200"
                                                        v-model="obj_Tournament.CDT"
                                                        :disabled="obj_Tournament.I > 0 && !obj_Tournament.enableEdit"
                                                        @input="TournamentStartDateChange(obj_Tournament.TD.startDate, obj_Tournament.CDT, obj_Tournament.CDV)"
                                                        ref="CDT" />
                                            <span class="ErrMsg">{{ ValidationTournamentErrMsg('CDT', 'PM', 'DT') }}</span>
                                        </CCol>
                                        <CCol col="1">
                                            <label class="col-form-label-sm">
                                                <span>{{this.getLanguage["PM"]["DW"]}} : </span>
                                            </label>
                                            <CInput :placeholder="getLanguage['PM']['DW']" :disabled="obj_Tournament.I > 0 && !obj_Tournament.enableEdit" size="sm" v-model="obj_Tournament.CDV" ref="CDV" @change="TournamentStartDateChange(obj_Tournament.TD.startDate, obj_Tournament.CDT, obj_Tournament.CDV)"></CInput>
                                            <span class="ErrMsg">{{ ValidationTournamentErrMsg('CDV', 'PM', 'DT') }}</span>
                                        </CCol>

                                        <CCol col="3">
                                            <label class="col-form-label-sm">{{this.getLanguage["TNMT"]["TNMT"]}} {{this.getLanguage["GL"]["SD"]}}<span class="required" /> :</label>
                                            <span v-if="obj_Tournament.I > 0 && !obj_Tournament.enableEdit">
                                                <CInput type="text" disabled size="sm" vertical :placeholder="this.getLanguage['GL']['SD']" :value="obj_Tournament.TD.startDate | moment('DD MMM YYYY HH:mm:ss')"></CInput>
                                            </span>
                                            <span v-else>
                                                <date-range-picker :autoApply="true"
                                                                   opens="right"
                                                                   :show-dropdowns="true"
                                                                   v-model="obj_Tournament.TD"
                                                                   @update="TournamentDateRangePickerUpdateEvent"
                                                                   :ranges="false"
                                                                   :single-date-picker="true"
                                                                   class="pcDaterange"
                                                                   :minDate="minDate"
                                                                   :readonly="obj_Tournament.I == 0 ? false : true">                                                                   
                                                    <div slot="input" slot-scope="picker">
                                                        <div v-if="obj_Tournament.TD.startDate != ''">
                                                            <CInput size="sm"
                                                                    :readonly="obj_Tournament.I == 0 ? false : true"
                                                                    :value="obj_Tournament.TD.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                                    @change="DateTimeChange('TD',$event)"
                                                                    style="background: #f9f9f9" />                                                            
                                                        </div>
                                                        <div v-else>
                                                            <CInput size="sm"
                                                                    :readonly="obj_Tournament.I == 0 ? false : true"
                                                                    @change="DateTimeChange('TD',$event)"
                                                                    style="background: #f9f9f9" />                                                            
                                                        </div>
                                                    </div>
                                                </date-range-picker>
                                            </span>
                                        </CCol>
                                        <CCol col="3">
                                            <label class="col-form-label-sm">{{this.getLanguage["TNMT"]["TNMT"]}} {{this.getLanguage["GL"]["ED"]}}<span class="required" /> :</label>
                                            <CInput type="text" disabled size="sm" vertical :placeholder="this.getLanguage['GL']['ED']" :value="DisplayTournamentEndDate(tournamentEndDate) | moment('DD MMM YYYY HH:mm:ss')"></CInput>                                            
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-3" v-if="this.dd_game != null && this.dd_game.length > 0">
                                        <!--<CCol col="12">
                                        <CTabs tabs >
                                            <CTab  v-for="(category,catIdx) in dd_game" :key="category.id" :titleHtml="category.label" :active="catIdx==0" >
                                                <div slot="title">{{category.label}}</div>
                                                <CRow class="">
                                                    <CCol col="10"><input type="checkbox" class="inline" @click="selectAll(catIdx)" v-model="bln_checkedAll[catIdx]" />{{ getLanguage["GL"]["ALL2"] }}</CCol>
                                                    <CCol v-for="(game,gameIdx) in category.children" :key="game.id" col="4" v-if="constHouseBrand.includes(game.id.split('-')[1])">
                                                        <CRow>
                                                            <CCol col="12"><input :value="game.id" type="checkbox" class="inline" v-model="obj_Tournament.GameIds" @change="checkSelectAllButton" />{{ renderProviderName(game.label) }}</CCol>
                                                        </CRow>
                                                    </CCol>
                                                    <CCol v-for="(game,gameIdx) in category.children" :key="game.id" col="4" v-if="!constHouseBrand.includes(game.id.split('-')[1])">
                                                        <CRow>
                                                            <CCol col="12"><input :value="game.id" type="checkbox" class="inline" v-model="obj_Tournament.GameIds" @change="checkSelectAllButton" />{{ renderProviderName(game.label) }}</CCol>
                                                        </CRow>
                                                    </CCol>
                                                </CRow>
                                            </CTab>
                                        </CTabs>
                                    </CCol>-->


                                        <CCol col="12">
                                            <div class="nav nav-tabs" id="nav-tab" role="tablist" style="font-size:12px">
                                                <button :class="(selectedGPCat == item.id)? 'p-2 nav-link active' : 'p-2 nav-link'" @click="selectedGPCat = item.id" v-for="(item, index) in dd_game" :key="index">{{renderCategoryName(item.label)}}</button>
                                            </div>
                                            <div class="card tab-content p-2 tempScrollbar" style="height: 150px; overflow: hidden scroll;">
                                                <div :class="item.id == selectedGPCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'" :id="'gp0-'+catIdx" v-for="(item, catIdx) in dd_game">
                                                    <div class="row">
                                                        <div class="col-md-4 text-red">
                                                            <div class="d-flex">
                                                                <input type="checkbox" :id="'gpcat'+item.id" class="inline custom-checkbox" @click="selectAll(catIdx)" v-model="bln_checkedAll[catIdx]" />
                                                                <label :for="'gpcat'+item.id" class="col-form-label-sm font-weight-bold ml-2">{{getLanguage["GL"]["ALL2"]}} </label>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4" v-for="gp in item.children" v-if="constHouseBrand.includes(gp.id)">
                                                            <div class="" style="gap: 5px; gap: 5px; display: grid !important;grid-template-columns: .2fr 3fr;">
                                                                <input type="checkbox" :id="'gp'+gp.id" class="inline custom-checkbox" v-model="obj_Tournament.GameIds" :value="gp.id" />
                                                                <label :for="'gp'+gp.id" class="col-form-label-sm font-weight-bold">{{renderProviderName(gp.label)}} </label>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4" v-for="gp in item.children" v-if="!constHouseBrand.includes(gp.id)">
                                                            <div class="" style="gap: 5px; gap: 5px; display: grid !important;grid-template-columns: .2fr 3fr;">
                                                                <input type="checkbox" :id="'gp'+gp.id" class="inline custom-checkbox" v-model="obj_Tournament.GameIds" :value="gp.id" />
                                                                <label :for="'gp'+gp.id" class="col-form-label-sm font-weight-bold">{{renderProviderName(gp.label)}} </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2"><span>3</span>{{this.getLanguage["TNMT"]["TP"]}}</h6>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage['TNMT']['PL']}}<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                            <CButton v-if="obj_Tournament.CI > 0 && currentPrizeRank < limitPrizeRank + 1" size="sm" color="outline-info" style="float: right;" @click="addPrize()" ref="TPrize"><span class='plusIcon cil-plus'></span>{{this.getLanguage["TNMT"]["ADP"]}}</CButton>

                                            <div class="mt-3">
                                                <span class="RAMsg">{{this.getLanguage["MTA"]["FTA"]}} : {{ CalculatePrizeAmount(currencySymbol) }}</span>
                                                <table class="custom-table custom-table-inPopUp afb-blue">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 15%;">{{this.getLanguage['GL']['ACT']}}</th>
                                                            <th style="width: 15%;">{{this.getLanguage["TNMT"]["R"]}}</th>
                                                            <th style="width: 15%;">{{this.getLanguage['TNMT']['TPC']}}</th>
                                                            <th>{{this.getLanguage['TNMT']['A']}}</th>
                                                            <th>{{this.getLanguage['TNMT']['RMK']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" v-if="obj_Tournament.TPrize == 0 || !obj_Tournament.TPrize">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_Tournament.TPrize">
                                                        <td>
                                                            <span id="actionBtnCol">
                                                                <i class="cil-trash" @click='removePrize(index)' v-if="index+1 == obj_Tournament.TPrize.length"></i> <!--here Remove -->
                                                                <i class="cil-color-border" @click='editPrize(data,index)'></i> <!--here Edit -->
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span>{{ data.R }}</span>
                                                            <span v-if="data.R != data.RT">- {{ data.RT }}</span>
                                                        </td>
                                                        <td>{{ currencySymbol }}</td>
                                                        <td>{{ThousandSeparator(data.A, getThousandCurrency ? 3 : 2)}}</td>
                                                        <td>
                                                            <span v-if="data.RMK != null && data.RMK != ''">{{ data.RMK }}</span>
                                                            <span v-else>-</span>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <span class="ErrMsg">{{ ValidationTournamentErrMsg('TPrize','TNMT', 'PL') }}</span>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveTournament()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isAPL">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{getLanguage["TNMT"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAddPrize()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol md="4">
                                        <div class="d-flex" style="gap:10px;">
                                            <div style=" width: 40%;">
                                                <label class="col-form-label-sm"> {{getLanguage["TNMT"]["R"]}} :</label>
                                                <CInput prepend="🏆" size="sm" :value="obj_prizelist.R" @change="v => obj_prizelist.R = v" disabled="disabled"></CInput>
                                                <span class="ErrMsg"></span>
                                            </div>

                                            <div style=" width: 20%;padding-left:10px" v-if="currentPrizeRank > 3">
                                                <label class="col-form-label-sm"> {{getLanguage["TNMT"]["T"]}}</label>
                                            </div>

                                            <div style=" width: 40%;" v-if="currentPrizeRank > 3 && obj_prizelist.I > 0">
                                                <label class="col-form-label-sm"> {{getLanguage["TNMT"]["R"]}} :</label>
                                                <CInput prepend="🏆" size="sm" :value="obj_prizelist.RT" @change="v => obj_prizelist.RT = v" disabled="disabled"></CInput>
                                            </div>
                                            <div style=" width: 40%;" v-if="currentPrizeRank > 3 && obj_prizelist.I == 0">
                                                <label class="col-form-label-sm"> {{getLanguage["TNMT"]["R"]}} :</label>
                                                <treeselect :multiple="false"
                                                            :options="dd_prizerank"
                                                            v-model="obj_prizelist.RT"
                                                            :clearable="false"
                                                            :disabled="obj_prizelist.I > 0" />
                                                <span class="ErrMsg">{{ ValidationPrizeErrMsg('TNMT','RT') }}</span>
                                            </div>
                                        </div>
                                    </CCol>
                                    <CCol md="4">
                                        <label class="col-form-label-sm"> {{getLanguage["TNMT"]["A"]}}<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                        <CInput vertical size="sm" :prepend="currencySymbol" :value="ThousandSeparator(obj_prizelist.A, getThousandCurrency ? 3 : 2)" @change="v => obj_prizelist.A = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" />
                                        <span class="ErrMsg">{{ ValidationPrizeErrMsg('TNMT','A') }}</span>
                                    </CCol>
                                    <CCol md="4">
                                        <label class="col-form-label-sm"> {{getLanguage["TNMT"]["RMK"]}} :</label>
                                        <CInput vertical size="sm" :placeholder="getLanguage['TNMT']['RMK']" :value="obj_prizelist.RMK" @change="v => obj_prizelist.RMK = v" />
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="savePrize()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isPreview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{ getLanguage["GL"]["P"] }}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isPreview = false">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="col-md-4 offset-md-8 d-flex  justify-content-end mt-3">
                                        <div class="showGridView" style="cursor:pointer;" @click="bool_isShowGrid = true">
                                            <i class="fa fa-th" aria-hidden="true"></i>
                                            <span class=""> Grid View</span>
                                        </div>
                                        <div class="showListView ml-4 active" style="cursor:pointer;"  @click="bool_isShowGrid = false">
                                            <i class="fa fa-list" aria-hidden="true"></i>
                                            <span class=""> List View</span>
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-center tournament-list " :class="bool_isShowGrid ? 'isGridView' : 'isListView'">
                                        <div class="tournament-wrapper activeTournament GCI-all GCI-12 GCI-5">
                                            <div class="ribbon-tour ribbon-top-left">
                                                <span>Active</span>
                                            </div>
                                            <div class="main-wrapper">
                                                <div class="row mx-0 tournament-bg" :style="getBgStyle(obj_Tournament.TIURL)">
                                                    <div class="tournament-info-wrapper">
                                                        <div>
                                                            <img class="img-fluid tournament-logo" :src="getImgUrl(obj_Tournament['TLIURL'])">
                                                            <div class="w-100">
                                                                <div class="position-relative" style="height:15px;">
                                                                    <div class="tournament-trc">
                                                                        <span class="mb-0">TID : 240402980056 </span>
                                                                        <span class="jmc"> (4)</span>
                                                                        <div class="hide jmc-tooltip">4 players participating this tournament</div>
                                                                    </div>
                                                                </div>
                                                                <h6 class="tournament-name my-1">{{ obj_Tournament['TN'] }}</h6>
                                                                <h6 class="tournament-leaderboard-prize mb-0">USD 99999.00</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="tournament-countdown-wrapper">
                                                        <div class="text-center tournament-countdown" data-day="02" data-month="04" data-year="2024">
                                                            <div class="d-flex justify-content-center">
                                                                <div class="countdown-circle">
                                                                    <div class="circle">
                                                                        <svg width="45" viewBox="0 0 220 220" xmlns="http://www.w3.org/2000/svg">
                                                                            <linearGradient id="myGradient">
                                                                                <stop class="circle-start-color" offset="0%" stop-color="#2575fc"></stop>
                                                                                <stop class="circle-offset-color" offset="50%" stop-color="#6a11cb"></stop>
                                                                            </linearGradient>
                                                                            <g transform="translate(110,110)">
                                                                                <circle r="100" class="e-c-base"></circle>
                                                                                <g transform="rotate(-90)">
                                                                                    <circle r="100" class="e-c-progress-days" stroke="url(#myGradient)" style="stroke-dasharray: 628.319px; stroke-dashoffset: -628.319px;"></circle>
                                                                                </g>
                                                                            </g>
                                                                        </svg>
                                                                    </div>
                                                                    <div class="controlls">
                                                                        <div class="display-remain-days">00</div>
                                                                        <div style="margin-top:-5px">Days</div>
                                                                    </div>
                                                                </div>
                                                                <div class="countdown-circle">
                                                                    <div class="circle">
                                                                        <svg width="45" viewBox="0 0 220 220" xmlns="http://www.w3.org/2000/svg">
                                                                            <linearGradient id="myGradient">
                                                                                <stop class="circle-start-color" offset="0%" stop-color="#2575fc"></stop>
                                                                                <stop class="circle-offset-color" offset="50%" stop-color="#6a11cb"></stop>
                                                                            </linearGradient>
                                                                            <g transform="translate(110,110)">
                                                                                <circle r="100" class="e-c-base"></circle>
                                                                                <g transform="rotate(-90)">
                                                                                    <circle r="100" class="e-c-progress-hours" stroke="url(#myGradient)" style="stroke-dasharray: 628.319px; stroke-dashoffset: -863.938px;"></circle>
                                                                                </g>
                                                                            </g>
                                                                        </svg>
                                                                    </div>
                                                                    <div class="controlls">
                                                                        <div class="display-remain-hours">09</div>
                                                                        <div style="margin-top:-5px">Hours</div>
                                                                    </div>
                                                                </div>
                                                                <div class="countdown-circle">
                                                                    <div class="circle">
                                                                        <svg width="45" viewBox="0 0 220 220" xmlns="http://www.w3.org/2000/svg">
                                                                            <linearGradient id="myGradient">
                                                                                <stop class="circle-start-color" offset="0%" stop-color="#2575fc"></stop>
                                                                                <stop class="circle-offset-color" offset="50%" stop-color="#6a11cb"></stop>
                                                                            </linearGradient>
                                                                            <g transform="translate(110,110)">
                                                                                <circle r="100" class="e-c-base"></circle>
                                                                                <g transform="rotate(-90)">
                                                                                    <circle r="100" class="e-c-progress-minutes" stroke="url(#myGradient)" style="stroke-dasharray: 628.319px; stroke-dashoffset: -1214.75px;"></circle>
                                                                                </g>
                                                                            </g>
                                                                        </svg>
                                                                    </div>
                                                                    <div class="controlls">
                                                                        <div class="display-remain-minutes">56</div>
                                                                        <div style="margin-top:-5px">Minutes</div>
                                                                    </div>
                                                                </div>
                                                                <div class="countdown-circle">
                                                                    <div class="circle">
                                                                        <svg width="45" viewBox="0 0 220 220" xmlns="http://www.w3.org/2000/svg">
                                                                            <linearGradient id="myGradient">
                                                                                <stop class="circle-start-color" offset="0%" stop-color="#2575fc"></stop>
                                                                                <stop class="circle-offset-color" offset="50%" stop-color="#6a11cb"></stop>
                                                                            </linearGradient>
                                                                            <g transform="translate(110,110)">
                                                                                <circle r="100" class="e-c-base"></circle>
                                                                                <g transform="rotate(-90)">
                                                                                    <circle r="100" class="e-c-progress-seconds" stroke="url(#myGradient)" style="stroke-dasharray: 628.319px; stroke-dashoffset: -1141.45px;"></circle>
                                                                                </g>
                                                                            </g>
                                                                        </svg>
                                                                    </div>
                                                                    <div class="controlls">
                                                                        <div class="display-remain-seconds">49</div>
                                                                        <div style="margin-top:-5px">Seconds</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="tournament-btngroup">
                                                        <button type="button" class="btn-learn-more rounded-pill " onclick="location.href='/en/tournamentdetails/114/2'">
                                                            Learn More
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="row mx-0 d-flex align-items-center justify-content-center h-100">
                                                    <div class="col-md-12 py-3 py-md-0 d-none d-md-block tournament-leaderboard">
                                                        <div id="leader114" class="leader carousel slide mb-0 slider-margin d-flex justify-content-center" data-ride="carousel" data-interval="false">
                                                            <div class="carousel-inner w-auto">
                                                                <div class="carousel-item active" data-ti="114" data-rt="5" data-ts="2" data-tfs="02/04/2024 12:00:00 AM" data-tos="02/04/2024 11:59:59 PM" data-cdt="1">
                                                                    <a href="/en/tournamentdetails/114/2"><h5 class="tournament-leaderboardtitle text-center my-2">Leaderboard</h5></a>
                                                                </div>
                                                            </div>
                                                            <a class="carousel-control-prev" href="#leader114" role="button" data-slide="prev" style="display:none">
                                                                <span class="carousel-control-prev-icon" aria-hidden="true" style="width:15px;height:15px;"></span>
                                                                <span class="sr-only">Prev</span>
                                                            </a>
                                                            <a class="carousel-control-next" href="#leader114" role="button" data-slide="next">
                                                                <span class="carousel-control-next-icon" aria-hidden="true" style="width: 15px; height: 15px;"></span>
                                                                <span class="sr-only">Next</span>
                                                            </a>
                                                        </div>
                                                        <div id="leaderBoard114" class="leaderboard position-relative m-auto">
                                                            <div class="rank-container" v-for="index in 5">
                                                                <div class="rank-icon-container">
                                                                    <img :src="'https://d2lcoivv20vty7.cloudfront.net/Content/media/torurmant/ranking/daily0'+ index +'.svg'" :class="'rankdaily-icon'+ index" loading="lazy">
                                                                    <span class="rank">{{index}}</span>
                                                                </div>
                                                                <div class="rank-info-container">
                                                                    <div>
                                                                        <p class="tournament-leaderboard-point">-</p>
                                                                    </div>
                                                                    <span class="tournament-leaderboard-prize text-right">-</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="tournament-overlay" style="display:none">
                                                            <span class="tournament-loader"></span>
                                                        </div>
                                                        <span class="hidden-langtext d-none" data-point="Points" data-norecord="No Records"></span>
                                                        <div class="leaderboard-btngroup">
                                                            <button type="button" class="btn-learn-more rounded-pill btn-block" onclick="location.href='/en/tournamentdetails/114/2'">
                                                                Learn More
                                                            </button>
                                                            <p class="mt-2 mb-0"><span></span></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <label class="mandatory_Field">** {{this.getLanguage["GL"]["PD"]}}</label>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SMB"]["TNMT"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addTournament()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["PM"]["AGI"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupfs"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["TNMT"]["TN"]}} :</span>
                                <CInput size="sm" :value="arr_FV['TN']" @change="v => arr_FV['TN'] = v"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['CTS']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['CTS'].startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['CTS'].startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['CTS']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['CTS'].endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['CTS'].endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>
        <div class="container-fluid">
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{ this.getLanguage["TNMT"]["TNMTL"] }}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.add)">{{ this.getLanguage["TNMT"]["TNMT"] }} {{getLanguage["PM"]["RS"]}}<i @click="setSortTable('TCS')" :class="setSortLogo('TCS')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["ORGN"] }}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>
                                    {{ this.getLanguage["TNMT"]["TN"] }}
                                    <i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i>
                                </th>
                                <th>{{ this.getLanguage["TNMT"]["TPIF"] }}</th>
                                <th>
                                    {{ this.getLanguage["TNMT"]["TDR"] }}
                                    <i @click="setSortTable('TSD')" :class="setSortLogo('TSD')" class="sortlogo"></i>
                                </th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["GL"]["CT"] }} /</span>
                                        <span class="grid-line">{{ this.getLanguage["GL"]["UTS"] }}</span>
                                    </div>
                                    <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo" style="margin-top: 9px;"></i>
                                </th>
                                <th> {{getLanguage["GL"]["UB"]}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.add)">{{ this.getLanguage["TNMT"]["TNMT"] }} {{getLanguage["PM"]["RS"]}}<i @click="setSortTable('TCS')" :class="setSortLogo('TCS')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["ORGN"] }}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>
                                    {{ this.getLanguage["TNMT"]["TN"] }}
                                    <i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i>
                                </th>
                                <th>{{ this.getLanguage["TNMT"]["TPIF"] }}</th>
                                <th>
                                    {{ this.getLanguage["TNMT"]["TDR"] }}
                                    <i @click="setSortTable('TSD')" :class="setSortLogo('TSD')" class="sortlogo"></i>
                                </th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["GL"]["CT"] }} /</span>
                                        <span class="grid-line">{{ this.getLanguage["GL"]["UTS"] }}</span>
                                    </div>
                                    <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo" style="margin-top: 9px;"></i>
                                </th>
                                <th> {{getLanguage["GL"]["UB"]}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_Tournament.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_Tournament">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">
                                <span id="actionBtnCol">
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block;">
                                        <i class="cil-trash" @click='removeTournament(data)'></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-else-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)" style="display: block;">
                                        <i class="cil-trash"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block;">
                                        <i class="cil-color-border" @click='editTournament(data.I)'></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-else-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)" style="display: block;">
                                        <i class="cil-color-border"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block;">
                                        <i class="fa fa-clone" @click='editTournament(data.I,true)'></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["C"]}}</span>
                                    </div>
                                    <div class="custom-tooltip" v-else-if="checkModuleAccess2(constAccessType.edit) && (isSENS==1 && data.AGI !=curAGI)" style="display: block;">
                                        <i class="fa fa-clone"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["C"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.add)">
                                <CCol col="4">
                                    <span v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="grid-line">
                                        <label class="switch">
                                            <input type="checkbox" true-value="2" false-value="1" v-model="data.RS" @click="updateStatus(data)">
                                            <span class="slider round"></span>
                                        </label>
                                    </span>
                                    <span v-else-if="(isSENS == 1 && data.AGI != curAGI)" class="grid-line">
                                        <label class="switch">
                                            <input type="checkbox" true-value="2" false-value="1" v-model="data.RS">
                                            <span class="slider round"></span>
                                        </label>
                                    </span>
                                    <span :style="renderTournamentStyle(data.TCS)">{{ renderTournamentCurrentStatus(data.TCS) }}</span>
                                </CCol>
                            </td>
                            <td>{{ renderAgentGroupName(data.GN, data.GPC) }}</td>
                            <td>
                                <router-link :to="{ path:'/R/TNMTR', query:{ tn: data.TN, df: data.LPTS != '1900-01-01T00:00:00' ? parseDateToJsonString(data.LPTS) : parseDateToJsonString(data.CTS), dt: parseDateToJsonString(setEndDate(data.TED)) }}">
                                    {{ data.TN }}
                                </router-link>
                            </td>
                            <td>
                                <span class="grid-line">
                                    <span>{{ renderTournamentType(data.CDT) }}</span>
                                    <span style="font-size: x-small;">({{ renderTournamentPointCalculationType(data.PCT) }})</span>
                                    <span style="font-size: x-small;">({{ data.ISOC }})</span>
                                </span>
                                <span class="grid-line">{{ getLanguage["TNMT"]["NTDR"] }} : {{ formatDateTime(data.NPT, "YYYY-MM-DD", "DD MMM YYYY") }}</span>
                                <span class="grid-line">
                                    {{ getLanguage["TNMT"]["LPTS"] }} :
                                    <span v-if="data.LPTS != '1900-01-01T00:00:00'">{{ formatDateTime(data.LPTS, "YYYY-MM-DD", "DD MMM YYYY") }}</span>
                                    <span v-else>-</span>
                                </span>
                            </td>
                            <td>
                                <span v-if="data.TSD != '1900-01-01T00:00:00' && data.TED != '1900-01-01T00:00:00'">
                                    <span class="grid-line">{{ formatDateTime(data.TSD, "YYYY-MM-DD", "DD MMM YYYY") }}</span>
                                    <span>{{ getLanguage["TNMT"]["T"] }} {{ formatDateTime(DisplayTournamentEndDate(data.TED, true), "YYYY-MM-DD", "DD MMM YYYY") }}</span>
                                </span>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <span class="grid-line">{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                <span class="grid-line">{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                            </td>
                            <td>{{ data.UB }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constTournamentType, constWeekday, constTournamentPointCalculationType } from '@/modules/Constant.js'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import DateRangePicker from 'vue2-daterange-picker'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex';
    import moment from "moment";
    import genericHelper from "@/modules/GenericHelper.js";
    import { required, numeric, requiredIf, alphaNum, decimal, minValue } from 'vuelidate/lib/validators'
    import { constAccessType, loadingFullScreen, constHouseBrand } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    import Editor from '@tinymce/tinymce-vue'

    Vue.use(require('vue-moment'));

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            'editor': Editor,
        },
        data() {
            return {
                selectedFileB: null,
                selectedFileL: null,
                selectedGPCat: "",
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                bool_isAMV: false, // Add Modal Visible
                bool_isAPL: false, // Add Modal Visible
                bool_showSearchBar: true,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                newImgB: false,
                newImgL: false,
                ISI_index: 0,
                ISLI_index: 0,
                arr_FV: {
                    "TN": "",
                    "TT": null,
                    "AGI": null,
                    "RS": 2,
                    "CTS": {
                        startDate: "",
                        endDate: ""
                    },
                },
                arr_Tournament: [],
                obj_Tournament: {
                    "I": 0,
                    "RS": 2,
                    "AGI": "",
                    "AGIT": null,
                    "TN": "",
                    "IAGI": "",
                    "CDT": null,
                    "CDV": "",
                    "TIURL": "",
                    "TLIURL": "",
                    "TD": { startDate: this.getTodayDate(), endDate: this.getTodayDate() },
                    "TSD": null,
                    "TED": null,
                    "TGI": "",
                    "GameIds": [],
                    "TGame": [],
                    "CI": null,
                    "TPrize": [],
                    "TDC": null,
                    "ISI": 1,
                    "ISLI": 1,
                    "PCT": 0,
                },
                obj_prizelist: {
                    I: 0,
                    R: null,
                    RT: null, // rankto
                    TPC: null,
                    A: 0,
                    RMK: null,
                },
                dd_agentgroup: [],
                dd_agentgroupfs: [],
                dd_tournamentBackground_ALL: [],
                dd_tournamentLogo_ALL: [],
                dd_tournamentBackground: [],
                dd_tournamentLogo: [],
                dd_TournamentPayoutOption: [],
                dd_TournamentPointCalculationType: [],
                dd_game: [],
                dd_gameCat: [],
                dd_prizerank: [],
                bool_gameloaded: false,
                bool_TournamentCV: false,
                bool_PrizeListCV: false,
                bool_isPreview: false,
                bool_isShowGrid: true,
                dd_weekday: [],
                dd_monthday: [],
                dd_currency: [],
                dd_language: [],
                currencySymbol: '',
                constAccessType: constAccessType,
                gameProviderList: [],
                bln_checkedAll: [],
                currentPrizeRank: 1,
                limitPrizeRank: 200,
                array_tnc: [],
                array_tn: [],
                visible: false,
                minDate: this.getTodayDate(),
                tournamentEndDate: this.getTodayDate(),
                constHouseBrand: [],
                selectedLang: "en",
                obj_Post: {
                    SelectedBrands: []
                },
                init: {
                    height: 450,
                    plugins: [
                        'lists advlist',
                        'image imagetools',
                        'link autolink',
                        'table',
                        'charmap',
                        'searchreplace visualblocks code fullscreen',
                        'print preview anchor insertdatetime',
                        'help codesample hr pagebreak nonbreaking toc textpattern noneditable',
                        'importcss',
                        'directionality',
                        'visualchars',
                        'emoticons',
                        'autosave',
                        'wordcount'
                    ],
                    toolbar:
                        'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
                    branding: false,
                    menubar: true,
                    file_picker_callback: function (cb) {
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/*');

                        input.onchange = function () {
                            this.bool_fullLoading = true;
                            var file = this.files[0];
                            var reader = new FileReader();

                            if (!file) {
                                return;
                            }
                            if (!file.name.match(/\.(jpg|jpeg|png)$/)) {
                                return;
                            }

                            reader.onload = function () {
                                var that = this;
                                var formData = new FormData();
                                formData.append('image', file)

                                Axios({
                                    url: 'https://api.imgur.com/3/image',
                                    method: 'POST',
                                    headers: {
                                        'Authorization': 'Client-ID ' + constImgURClientId
                                    },
                                    data: formData
                                })
                                    .then((result) => {
                                        let url = result.data.data.link;
                                        that.bool_fullLoading = true;
                                        cb(url, { title: file.name });
                                    })
                                    .catch((err) => {
                                        that.bool_fullLoading = true;
                                        console.log(err);
                                    });
                            };
                            reader.readAsDataURL(file);
                        };
                        input.click();
                    }
                },             
            }
        },
        validations: {
            obj_prizelist: {
                R: { required },
                A: { required }
            },
            obj_Tournament: {
                "TN": { required },
                "CDT": { required },
                "CDV": { required },
                "TSD": { required },
                "TED": { required },
                "TPrize": { required },
                "TDC": { required },
                "PCT": { required },
                "CI": { required }
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_TournamentCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getTournamentList();
            },
        },
        methods: {
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            DateTimeChange(type, event) {
                if (type == "TD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.obj_Tournament.TD.startDate = dateObj;
                        this.TournamentStartDateChange(this.obj_Tournament.TD.startDate, this.obj_Tournament.CDT, this.obj_Tournament.CDV);
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.obj_Tournament.TD.startDate = this.getTodayDate();
                        this.TournamentStartDateChange(this.obj_Tournament.TD.startDate, this.obj_Tournament.CDT, this.obj_Tournament.CDV);
                    }
                }
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.CTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.CTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.CTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.CTS.endDate = "";
                    }
                }
            },
            DisplayTournamentEndDate(tournamentEndDate, isToString = false) {

                if (isToString) {
                    return moment(tournamentEndDate).subtract('seconds', 1).format("YYYY-MM-DD HH:mm:ss");
                }

                return moment(tournamentEndDate).subtract('seconds', 1);
            },
            TournamentImageChange(tournamentType, imageURL){
                if(tournamentType == 1){
                    this.obj_Tournament.ISI = 1;
                    this.obj_Tournament.TIURL = imageURL;
                    this.newImgB = false;
                }
                else if(tournamentType == 2){
                    this.obj_Tournament.ISLI = 1;
                    this.obj_Tournament.TLIURL = imageURL;
                    this.newImgL = false;
                }
            },
            TournamentStartDateChange(tournamentStartDate, PayoutMethod, PayoutUntil){
                this.tournamentEndDate = tournamentStartDate;
                if (PayoutMethod != null && PayoutUntil != null) {
                    if (PayoutMethod == 1) { //daily
                        this.tournamentEndDate = moment(tournamentStartDate).add(PayoutUntil, 'd');
                    }
                    if (PayoutMethod == 2) { // weekly
                        this.tournamentEndDate = moment(tournamentStartDate).add(PayoutUntil, 'w');
                    }
                    if (PayoutMethod == 3) { //monthly
                        this.tournamentEndDate = moment(tournamentStartDate).add(PayoutUntil, 'M');
                    }
                }
                return moment(this.tournamentEndDate, 'DD MMM YYYY HH:mm:ss').toString();
            },
            onFileSelectedB(event) {
                this.obj_Tournament['TIURL'] = null;
                this.selectedFileB = this.validateFile(event);
                this.newImgB = true;
                this.obj_Tournament.ISI = 0;
            },
            onFileSelectedL(event) {
                this.obj_Tournament['TLIURL'] = null;
                this.selectedFileL = this.validateFile(event);
                this.newImgL = true;
                this.obj_Tournament.ISLI = 0;
            },
            getRankCount(val) {
                this.dd_prizerank = [];
                for (var i = val; i <= this.limitPrizeRank; i++) {
                    this.dd_prizerank.push({ id: i, label: i });
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('TNMT', 'P', type);
            },
            closeAdd() {
                this.selectedFileB = null;
                this.selectedFileL = null;
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_TournamentCV = false;
            },
            closeAddPrize() {
                this.bool_isAPL = !this.bool_isAPL;
                this.bool_PrizeListCV = false;
                this.obj_prizelist = {
                    I: 0,
                    R: null,
                    RT: null, // rankto
                    TPC: null,
                    A: 0,
                    RMK: null,
                };
                this.dd_prizerank = [];
            },
            addPrize() {
                this.obj_prizelist = {
                    I: 0,
                    R: this.currentPrizeRank,
                    RT: this.currentPrizeRank, // rankto
                    TPC: null,
                    A: 0,
                    RMK: null,
                };
                if (this.currentPrizeRank > 3) {
                    this.getRankCount(this.currentPrizeRank);
                }
                this.bool_isAPL = true;
            },
            savePrize() {
                this.bool_PrizeListCV = true;
                this.$v.obj_prizelist.$touch();
                if (!this.$v.obj_prizelist.$error) {

                    if (!this.obj_Tournament.TPrize) {
                        this.obj_Tournament.TPrize = [];
                    }

                    if (this.obj_prizelist.RT == null) {
                        this.obj_prizelist.RT = this.obj_prizelist.R;
                    }

                    var exist = false;
                    for (var i = 0; i < this.obj_Tournament.TPrize.length; i++) {

                        if (this.obj_Tournament.TPrize[i].R == this.obj_prizelist.R) {
                            exist = true;
                            this.obj_Tournament.TPrize[i] = this.obj_prizelist;
                            this.bool_isAPL = false;
                            this.bool_PrizeListCV = false;
                            this.obj_prizelist = {};
                            this.dd_prizerank = [];
                        }

                    }

                    if (!exist) {

                        this.obj_prizelist.I = 1;
                        this.obj_Tournament.TPrize.push(this.obj_prizelist);
                        this.bool_isAPL = false;
                        this.bool_PrizeListCV = false;
                        if (this.obj_prizelist.R == this.obj_prizelist.RT) {
                            this.currentPrizeRank += 1;
                        }
                        else {
                            this.currentPrizeRank = this.obj_prizelist.RT + 1;
                        }
                        this.obj_prizelist = {};
                        this.dd_prizerank = [];

                    }
                }
            },
            removePrize(index) {
                this.currentPrizeRank = this.obj_Tournament.TPrize[index].R;
                this.$delete(this.obj_Tournament.TPrize, index);
                this.$forceUpdate();
            },
            editPrize(data, index) {
                this.bool_PrizeListCV = false;
                this.obj_prizelist = Object.assign({}, data);
                this.bool_isAPL = true;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getTournamentList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getTournamentList();
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            CurrencyChange(value) {
                if (value != undefined) {
                    var that = this;
                    this.dd_currency.find(function (val, idx) {
                        if (val.id == value) {
                            that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);
                            that.currencySymbol = val.label2;
                        }
                    });
                }
            },
            CalculatePrizeAmount(CS) {
                var totalAmount = 0;
                if (this.obj_Tournament.TPrize != null) {
                    for (var i = 0; i < this.obj_Tournament.TPrize.length; i++) {
                        var amount = 0;
                        amount = parseFloat(this.obj_Tournament.TPrize[i].A) * (parseInt(this.obj_Tournament.TPrize[i].RT) - parseInt(this.obj_Tournament.TPrize[i].R) + 1)
                        totalAmount += amount;
                    }
                    return this.formatNumber(totalAmount, this.getThousandCurrency ? 3 : 2, CS);
                }
                else {
                    return this.formatNumber(totalAmount, this.getThousandCurrency ? 3 : 2, CS);
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getTournamentList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getDropdownList() {
                var that = this;

                this.dd_TournamentPayoutOption = [{
                    id: 1,
                    label: this.getLanguage['PM']['DLY']
                }, {
                    id: 2,
                    label: this.getLanguage['PM']['WLY']
                }, {
                    id: 3,
                    label: this.getLanguage['PM']['MLY']
                    }];

                this.dd_TournamentPointCalculationType = [{
                    id: 0,
                    label: this.getLanguage['PM']['DPS']
                }, {
                    id: 1,
                    label: this.getLanguage['PM']['TTO']
                }, {
                    id: 2,
                    label: this.getLanguage['PM']['TW']
                }, {
                    id: 3,
                    label: this.getLanguage['PM']['TL']
                }];
                this.dd_weekday = [{
                    id: "1",
                    label: this.getLanguage['GL']['WD1']
                }, {
                    id: "2",
                    label: this.getLanguage['GL']['WD2']
                }, {
                    id: "3",
                    label: this.getLanguage['GL']['WD3']
                }, {
                    id: "4",
                    label: this.getLanguage['GL']['WD4']
                }, {
                    id: "5",
                    label: this.getLanguage['GL']['WD5']
                }, {
                    id: "6",
                    label: this.getLanguage['GL']['WD6']
                }, {
                    id: "0",
                    label: this.getLanguage['GL']['WD7']
                }];

                this.dd_monthday = [];

                for (var i = 1; i <= 28; i++) {
                    this.dd_monthday.push({
                        id: i,
                        label: i
                    });
                }

                this.getDataApi(`/api/dd/tnmtsysimage/1`,
                    function (d, s) {
                        if (s) {
                            that.dd_tournamentBackground_ALL = d.dropdownlist;
                            that.dd_tournamentBackground = d.dropdownlist;
                        }
                    });

                this.getDataApi(`/api/dd/tnmtsysimage/2`,
                    function (d, s) {
                        if (s) {
                            that.dd_tournamentLogo_ALL = d.dropdownlist;
                            that.dd_tournamentLogo = d.dropdownlist;
                        }
                    });

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }
                        }
                    });

            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            renderTournamentGP(list_BonusGame) {
                var result = "";
                try {
                    if (list_BonusGame != null && list_BonusGame != "") {
                        var gameList = list_BonusGame.split(",");
                        for (var i = 0; i < gameList.length; i++) {
                            try {
                                if (i > 0) {
                                    result += " / ";
                                }
                                var GPro = this.gameProviderList.find(o => o.id === gameList[i].split("-")[1]);
                                if (GPro)
                                    result += this.renderProviderName(GPro.label);
                            }
                            catch (ex) {
                                result += "/ Disabled Provider "
                                console.log(ex);
                            }
                        }
                    }
                    else {
                        result = this.getLanguage['GL']['ALL']
                    }
                }
                catch (err) {
                    result = "Provider Temporary Unavailable";
                    console.log(err);
                }
                return result;
            },
            getGameProviderList() {
                var that = this;
                this.getDataApi(`/api/dd/gameProv`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label2);
                            }
                            that.gameProviderList = d.dropdownlist;
                        }
                        else {
                            that.gameProviderList = null;
                        }

                    });
            },
            getTournamentList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }
                    path += (
                        "f.TN=" + (this.arr_FV["TN"] == null ? "" : this.arr_FV["TN"]) +
                        "&f.TT=" + (this.arr_FV["TT"] == null ? "" : this.arr_FV["TT"]) +
                        "&f.AGI=" + (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]));

                    if (this.arr_FV.CTS.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.CTS.startDate);
                        path += "&f.CTS_from=" + cts_from;
                    }
                    if (this.arr_FV.CTS.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.CTS.endDate);
                        path += "&f.CTS_to=" + cts_to;
                    }
                }

                this.getDataApi(`/api/tournament/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            if (d.D.Items == null) {
                                that.arr_Tournament = [];
                            }
                            else {
                                that.arr_Tournament = d.D.Items;
                            }
                            that.resizeTableHead();
                        }
                    });

            },
            GetGameProvider() {
                var that = this;
                this.bool_gameloaded = false;
                this.getDataApi('/api/dd/game/provexcludecategory/0/0/1',
                    function (d, s) {
                        if (s) {
                            that.bool_gameloaded = true;
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderCategory(d.dropdownlist[i].id);
                            }
                            that.dd_game = d.dropdownlist;
                            that.selectedGPCat = that.dd_game[0].id;
                            that.$set(that.$data, 'dd_game', d.dropdownlist);

                            if(that.dd_game != null && that.dd_game.length > 0){
                                that.dd_gameCat.push({ id: '0', label: that.renderAll() })
                                for(var i = 0; i < that.dd_game.length; i++){
                                    that.dd_gameCat.push({ id: that.dd_game[i].label, label: that.dd_game[i].label })
                                }
                            }
                        }
                    });
            },
            renderAll() {
                return this.getLanguage["GL"]["ALL2"];
            },
            renderCategory(id) {
                return this.getLanguage["GC"][id];
            },
            AgentGroupChange(value) {
                var agiList = [];

                if (value && value.length > 0) {

                    for (var i = 0; i < value.length; i++) {
                        if (value[i].split("-")[0] == 3) {
                            agiList.push(value[i].split("-")[1]);
                        }
                    }

                    if (agiList.length > 0) {
                        var that = this;

                        this.obj_Post.SelectedBrands = agiList;

                        this.postDataApi(`/api/dd/langbyaglist`, this.obj_Post,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.dd_language = d.dropdownlist;

                                    if (that.dd_language.length > 0) {
                                        that.selectedLang = that.dd_language[0].id;
                                    }
                                }
                            });

                        this.dd_currency = [];
                        this.postDataApi(`/api/dd/curbyagilist`, this.obj_Post,
                            function (d, s) {
                                if (s) {
                                    that.dd_currency = d.dropdownlist;                                    
                                    if (that.obj_Tournament.CI > 0) {                                        
                                        if (that.dd_currency.find(val => val.id === that.obj_Tournament.CI.toString())) {
                                            that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);
                                            that.currencySymbol = val.label2;
                                        }
                                        else {
                                            that.obj_Tournament.CI = null;
                                        }                                                                           
                                    }
                                }
                            });
                    }
                    else {
                        this.dd_language = [];
                    }
                }
                else {
                    this.obj_Post.SelectedBrands = [];
                    this.dd_agentgroup.forEach(this.LoopAgentGroupParent);

                    if (this.obj_Post.SelectedBrands.length > 0) {
                        var that = this;

                        this.postDataApi(`/api/dd/langbyaglist`, this.obj_Post,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.dd_language = d.dropdownlist;

                                    if (that.dd_language.length > 0) {
                                        that.selectedLang = that.dd_language[0].id;
                                    }
                                }
                            });

                        this.dd_currency = [];
                        this.postDataApi(`/api/dd/curbyagilist`, this.obj_Post,
                            function (d, s) {
                                if (s) {
                                    that.dd_currency = d.dropdownlist;
                                    if (that.obj_Tournament.CI > 0) {
                                        if (that.dd_currency.find(val => val.id === that.obj_Tournament.CI.toString())) {
                                            that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);
                                            that.currencySymbol = val.label2;
                                        }
                                        else {
                                            that.obj_Tournament.CI = null;
                                        }
                                    }
                                }
                            });
                    }
                    else {
                        this.dd_language = [];
                    }
                }
            },
            LoopAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] == "3") {
                    this.obj_Post.SelectedBrands.push(agi[1]);
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.LoopAgentGroupParent);
                }
            },
            GameCatChange(tournamentType, categoryName) {
                if(tournamentType == 1){
                    if(categoryName != '0'){
                        let result = this.dd_tournamentBackground_ALL.filter(obj => { return obj.extraCat === categoryName });
                        this.dd_tournamentBackground = result;
                    }
                    else{
                        this.dd_tournamentBackground = this.dd_tournamentBackground_ALL;
                    }
                }
                else if(tournamentType == 2){
                    if(categoryName != '0'){
                        let result = this.dd_tournamentLogo_ALL.filter(obj => { return obj.extraCat === categoryName });
                        this.dd_tournamentLogo = result;
                    }
                    else{
                        this.dd_tournamentLogo = this.dd_tournamentLogo_ALL;
                    } 
                }   
            },
            AgentGroupChangefs(value) {
                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                    }
                    that.arr_FV["AGI"] = agi;
                }
                else {
                    this.arr_FV["AGI"] = null;
                }
            },
            HTMLEditorTextChange(value, langId) {
                this.array_tnc[langId] = value.level.content;
            },
            ValidationPrizeErrMsg(value, langKey = "") {
                if (this.bool_PrizeListCV) {
                    var validateObj = this.$v.obj_prizelist[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["TNMT"][langKey]);
                    }
                }
            },
            ValidationTournamentErrMsg(value, langKey1 = "", langKey2 = "") {
                if (this.bool_TournamentCV) {
                    if (langKey1 == "") {
                        langKey1 = "TNMT";
                    }

                    if (langKey2 == "") {
                        langKey2 = value;
                    }

                    if (value == "CDT") {
                        if (this.obj_Tournament.CDT == 0)
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                    }

                    if (value == "CDV") {
                        if (!this.obj_Tournament.CDV)
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                        else if (isNaN(this.obj_Tournament.CDV))
                            return String.format(this.utilGetErrorLanguage('1009'), this.getLanguage[langKey1][langKey2]);
                        else if (this.obj_Tournament.CDV <= 0)
                            return String.format(this.utilGetErrorLanguage('4442'), this.getLanguage[langKey1][langKey2]);
                    }

                    var validateObj = this.$v.obj_Tournament[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.alphaNum != undefined && !validateObj.alphaNum) {
                        return String.format(this.utilGetErrorLanguage('1008'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.numeric != undefined && !validateObj.numeric) {
                        return String.format(this.utilGetErrorLanguage('1009'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.between != undefined && !validateObj.between) {
                        return String.format(this.utilGetErrorLanguage('1004'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.minValueValue != undefined && !validateObj.minValueValue) {
                        return String.format(this.utilGetErrorLanguage('4442'), this.getLanguage[langKey1][langKey2]);
                    }

                }
            },
            addTournament() {
                this.bool_TournamentCV = false;
                this.bool_fullLoading = true;

                this.obj_Tournament = {
                    "I": 0,
                    "RS": 2,
                    "AGI": "",
                    "AGIT": null,
                    "TN": "",
                    "IAGI": "",
                    "CDT": null,
                    "CDV": "",
                    "TIURL": "",
                    "TLIURL": "",
                    "TD": { startDate: this.getTodayDate(), endDate: this.getTodayDate() },
                    "TSD": null,
                    "TED": null,
                    "TGI": "",
                    "GameIds": [],
                    "TGame": [],
                    "CI": null,
                    "TPrize": [],
                    "TDC": null,
                    "ISI": 1,
                    "ISLI": 1,
                    "PCT": 0,
                },
                this.array_tnc = [];
                this.array_tn = [];
                this.obj_Post.SelectedBrands = [];
                this.newImgB = false;
                this.newImgL = false;
                this.ISI_index = 0,
                this.ISLI_index = 0,
                this.currentPrizeRank = 1;
                this.visible = false;
                this.tournamentEndDate = this.getTodayDate();
                this.AgentGroupChange();

                if (this.bln_checkedAll != null && this.bln_checkedAll.length > 0) {
                    for (var i = 0; i < this.bln_checkedAll.length; i++) {
                        this.bln_checkedAll[i] = false;
                    }
                }

                this.bool_isAMV = true;
                this.bool_fullLoading = false;

            },
            editTournament(id, bool_copy = false) {
                var that = this;

                this.bool_fullLoading = true;
                this.bool_groupCV = false;
                this.bool_TournamentCV = false;
                this.visible = false;
                this.ISI_index = 0,
                this.ISLI_index = 0,

                this.getDataApi(`/api/tournament/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {

                            that.obj_Tournament = Object.assign(that.obj_Tournament, d.D);

                            var gameIds = [];
                            if (that.obj_Tournament.TGI != null && that.obj_Tournament.TGI.length > 0) {
                                gameIds = that.obj_Tournament.TGI.split(',');
                            }

                            that.$set(that.$data.obj_Tournament, 'GameIds', gameIds);

                            var IAGI_temp = [];
                            if (that.obj_Tournament.IAGI != null && that.obj_Tournament.IAGI.length > 0) {
                                var temp = that.obj_Tournament.IAGI.split(",");
                                for (var i = 0; i < temp.length; i++) {
                                    IAGI_temp.push(temp[i]);
                                }
                            }
                            that.obj_Tournament.AGIT = IAGI_temp;
                            that.AgentGroupChange(that.obj_Tournament.AGIT);

                            if (that.obj_Tournament.TPrize != null && that.obj_Tournament.TPrize.length > 0) {
                                if (that.obj_Tournament.TPrize[that.obj_Tournament.TPrize.length - 1].R == that.obj_Tournament.TPrize[that.obj_Tournament.TPrize.length - 1].RT) {
                                    that.currentPrizeRank = that.obj_Tournament.TPrize[that.obj_Tournament.TPrize.length - 1].R + 1;
                                }
                                else {
                                    that.currentPrizeRank = that.obj_Tournament.TPrize[that.obj_Tournament.TPrize.length - 1].RT + 1;
                                }
                            }
                            
                            that.obj_Tournament.TD = {
                                startDate: that.getTodayDate(),
                                endDate: that.getTodayDate()
                            };

                            if (that.obj_Tournament.TSD != null) {
                                that.obj_Tournament.TD.startDate = that.obj_Tournament.TSD;
                            }

                            if (that.obj_Tournament.TED != null) {
                                that.obj_Tournament.TD.endDate = that.obj_Tournament.TED;
                                that.tournamentEndDate = that.obj_Tournament.TED;
                            }

                            that.checkSelectAllButton();

                            var tn = [];
                            var tn_list = [];
                            tn = that.$data.obj_Tournament.TMultiLangTNList;
                            if (tn.length > 0) {
                                tn.forEach(function (item) {
                                    tn_list[item.L] = item.TN;
                                });
                            }
                            that.array_tn = tn_list;

                            var tnc = [];
                            var tnc_list = [];
                            tnc = that.$data.obj_Tournament.TMultiLangTTNCList;
                            if (tnc.length > 0) {
                                tnc.forEach(function (item) {
                                    tnc_list[item.L] = item.TTNC;
                                });
                            }
                            that.array_tnc = tnc_list;

                            that.bool_isAMV = true;
                        }

                        if (bool_copy == true) {
                            that.obj_Tournament.I = 0;
                        }
                    });
            },
            populateGameIds() {
                if (this.dd_game != null && this.dd_game.length > 0) {
                    // if PGame is blank, push all in
                    if (this.obj_Tournament.TGame == null || this.obj_Tournament.TGame.length == 0) {

                        for (var i = 0; i < this.dd_game.length; i++) {
                            if (this.dd_game[i].children != null && this.dd_game[i].children.length > 0) {
                                for (var j = 0; j < this.dd_game[i].children.length; j++) {
                                    if (this.obj_Tournament.GameIds.indexOf(this.dd_game[i].children[j].id) < 0) {
                                        this.obj_Tournament.GameIds.push(this.dd_game[i].children[j].id);
                                    }
                                }
                            }
                        }
                    }
                }
            },
            saveTournament() {

                this.bool_fullLoading = true;
                this.bool_fullScreen = true;

                var that = this;

                if (this.obj_Tournament.GameIds != null && this.obj_Tournament.GameIds.length > 0) {
                    this.obj_Tournament.TGI = this.obj_Tournament.GameIds.join(',');
                } else {
                    this.obj_Tournament.TGI = "";
                }

                var tn = [];

                for (const [key, value] of Object.entries(this.array_tn)) {
                    if (key != "") {
                        var tn_temp = {
                            L: key,
                            TN: value,
                        };
                        tn.push(tn_temp);
                    }
                }

                this.obj_Tournament.TMultiLangTNList = tn;

                var tnc = [];

                for (const [key, value] of Object.entries(this.array_tnc)) {
                    if (key != "") {
                        var tnc_temp = {
                            L: key,
                            TTNC: value,
                        };
                        tnc.push(tnc_temp);
                    }
                }

                this.obj_Tournament.TMultiLangTTNCList = tnc;

                if (this.obj_Tournament.GameIds != null && this.obj_Tournament.GameIds.length > 0) {
                    this.obj_Tournament.TGame = [];
                    for (var i = 0; i < this.dd_game.length; i++) {
                        if (this.dd_game[i].children != null && this.dd_game[i].children.length > 0) {
                            for (var j = 0; j < this.dd_game[i].children.length; j++) {
                                if (this.obj_Tournament.GameIds.indexOf(this.dd_game[i].children[j].id) >= 0) {
                                    var gcpi = this.dd_game[i].children[j].id.split("-");
                                    this.obj_Tournament.TGame.push({
                                        "I": 0,
                                        "RS": 2,
                                        "GCI": gcpi[0],
                                        "GPI": gcpi[1]
                                    });
                                }
                            }
                        }
                    }
                }

                if (this.obj_Tournament.AGIT != null && this.obj_Tournament.AGIT.length > 0) {
                    this.obj_Tournament.IAGI = this.obj_Tournament.AGIT.join(',');
                } else {
                    this.obj_Tournament.IAGI = "";
                }

                if (this.obj_Tournament.TD != null) {
                    if (this.obj_Tournament.TD.startDate != null) {
                        this.obj_Tournament.TSD = this.parseDateToJsonString(this.obj_Tournament.TD.startDate);
                        this.obj_Tournament.TED = this.parseDateToJsonString(this.tournamentEndDate);
                    }
                }

                this.bool_TournamentCV = true;
                this.$v.obj_Tournament.$touch();
                var formValid = true;
                if (this.obj_Tournament.CDT == 0)
                    formValid = false;
                else if (!this.obj_Tournament.CDV || (this.obj_Tournament.CDV && (isNaN(this.obj_Tournament.CDV) || this.obj_Tournament.CDV < 0)))
                    formValid = false;

                if (!this.$v.obj_Tournament.$error && formValid) {
                    var that = this;
                    if(this.newImgB == false && this.obj_Tournament.TIURL == ''){
                        that.bool_fullLoading = false;
                        that.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["TNMT"]["TIMURL"]));
                    }
                    else if(this.newImgL == false && this.obj_Tournament.TLIURL == ''){
                        that.bool_fullLoading = false;
                        that.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["TNMT"]["TLIMURL"]));
                    }
                    else if (this.newImgB == true || this.newImgL == true) {
                        //if new image is selected
                        if(this.newImgB == true){
                            that.obj_Tournament["tournamentImageB"] = that.selectedFileB;
                            this.obj_Tournament.ISI = 0;
                        }
                        if(this.newImgL == true){
                            that.obj_Tournament["tournamentImageL"] = that.selectedFileL;
                            this.obj_Tournament.ISLI = 0;
                        }
                        this.postDataApiWithAttach(`/api/tournament/s`, this.obj_Tournament, function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.selectedFileB = null;
                                that.selectedFileL = null;
                                that.currentPrizeRank = 1;
                                that.getTournamentList();
                            }
                        });
                    } else if (this.newImgB == false && this.newImgL == false) {
                        that.obj_Tournament["tournamentImageB"] = null;
                        that.obj_Tournament["tournamentImageL"] = null;
                        //if user edit, but want to retain image
                        this.postDataApiWithAttach(`/api/tournament/s`, this.obj_Tournament, function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.selectedFileB = null;
                                that.selectedFileL = null;
                                that.currentPrizeRank = 1;
                                that.getTournamentList();
                            }
                        });
                    } else {
                        that.bool_fullLoading = false;
                        that.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["TNMT"]["TIMURL"]));
                    }
                } else {
                    this.bool_fullLoading = false;

                    //get the object for validating.
                    const validation = this.$v["obj_Tournament"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            removeTournament(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/tournament/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getTournamentList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            renderTournamentCurrentStatus(statusCode) {
                return this.getLanguage['TNMT']['TS' + statusCode];
            },
            renderTournamentType(type) {
                return this.dd_TournamentPayoutOption[type - 1].label;
                //for (var i = 0; i < constTournamentType.length; i++) {
                //    if (constTournamentType[i].id == type)
                //        return constTournamentType[i].label;
                //}
                //return "-";
            },
            renderTournamentPointCalculationType(pointCalculationType) {
                return this.dd_TournamentPointCalculationType[pointCalculationType].label;
                //for (var i = 0; i < constTournamentPointCalculationType.length; i++) {
                //    if (constTournamentPointCalculationType[i].id == pointCalculationType)
                //        return constTournamentPointCalculationType[i].label;
                //}
                //return "-";
            },
            renderTournamentStyle(currentStatus) {
                if (currentStatus == 0) {
                    return { 'font-size': 'x-small', color: '#191919' };
                }
                if (currentStatus == 1) {
                    return { 'font-size': 'x-small', color: '#e8a317' };
                }
                else if (currentStatus == 2) {
                    return { 'font-size': 'x-small', color: '#0372ff' };
                }
                else if (currentStatus == 3) {
                    return { 'font-weight': 'bold', 'font-size': 'x-small', color: '#191919' };
                }

            },
            updateStatus(d) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CA"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;

                        this.postDataApi(`/api/tournament/us`, d,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.bool_isAMV = false;
                                    that.getTournamentList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                    else {
                        this.getTournamentList();
                    }
                });

            },
            clearDateRangeFilter() {
                this.arr_FV.CTS = {
                    startDate: "",
                    endDate: ""
                };
            },
            selectAll(tabIndex) {
                this.bln_checkedAll[tabIndex] = (this.bln_checkedAll[tabIndex]) ? false : true;

                if (this.bln_checkedAll[tabIndex]) {
                    if (this.dd_game[tabIndex].children != null && this.dd_game[tabIndex].children.length > 0) {
                        for (var j = 0; j < this.dd_game[tabIndex].children.length; j++) {
                            if (this.obj_Tournament.GameIds.indexOf(this.dd_game[tabIndex].children[j].id) < 0) {
                                this.obj_Tournament.GameIds.push(this.dd_game[tabIndex].children[j].id);
                            }
                        }
                    }
                } else {
                    if (this.dd_game[tabIndex].children != null && this.dd_game[tabIndex].children.length > 0) {
                        for (var j = 0; j < this.dd_game[tabIndex].children.length; j++) {
                            var tempItem = this.obj_Tournament.GameIds.indexOf(this.dd_game[tabIndex].children[j].id);
                            if (tempItem >= 0) {
                                this.obj_Tournament.GameIds.splice(tempItem, 1);
                            }
                        }
                    }
                }
            },
            TournamentDateRangePickerUpdateEvent(dt) {
                if (dt) {
                    if (dt.startDate) {
                        dt.startDate.setHours(0, 0, 0, 0);
                    }

                    if (dt.endDate) {
                        dt.endDate.setHours(23, 59, 59, 59, 997);
                    }
                }
                this.obj_Tournament.TD.startDate = dt.startDate;
                this.obj_Tournament.TD.endDate = dt.endDate;
                this.TournamentStartDateChange(this.obj_Tournament.TD.startDate, this.obj_Tournament.CDT, this.obj_Tournament.CDV)
            },
            checkSelectAllButton() {
                for (const tabIndex in this.dd_game) {
                    this.bln_checkedAll[tabIndex] = false;
                    if (this.dd_game[tabIndex].children != null && this.dd_game[tabIndex].children.length > 0) {
                        for (var j = 0; j < this.dd_game[tabIndex].children.length; j++) {
                            if (this.obj_Tournament.GameIds.indexOf(this.dd_game[tabIndex].children[j].id) >= 0) {
                                this.bln_checkedAll[tabIndex] = true;
                            } else {
                                this.bln_checkedAll[tabIndex] = false;
                                break;
                            }
                        }
                    }
                }
            },
            setFlag(languageCode) {
                return this.mapLanguageFlag(languageCode);
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            getBgStyle(imgPath) {
                return 'background: url(' + imgPath + '); background-size: cover; background-position: center;';
            }
        },
        created() {
            this.$parent.showSubMenu = 'P';
            this.$parent.showActiveMenu = 'P.TNMT';
            this.moduleIndex = this.checkModuleIndex('TNMT', 'P', constAccessType.view, '', -1);
            if (this.moduleIndex == '6.9.1') {
                this.$parent.showSubSubMenu = 'TOUR2';
            }

            this.getDropdownList();
            this.getTournamentList();
            this.getGameProviderList();
            this.GetGameProvider();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;

            this.constHouseBrand = constHouseBrand;
        }
    }
</script>

<style lang="scss">
    .pcDaterange .reportrange-text {
        display: block;
        padding: 0 !important;
        margin-top: -1px;
    }

    .flagClass {
        height: 20px;
        width: 20px;
    }


    .countdown-circle {
        width: 45px;
        height: 45px;
        position: relative
    }

    .countdown-circle .circle #myGradient .circle-start-color {
        stop-color: #2575fc;
    }

    .countdown-circle .circle #myGradient .circle-offset-color {
        stop-color: #6a11cb;
    }

    .controlls {
        right: auto;
        color: white;
        text-transform: uppercase;
        font-weight: 500;
        color: #ffffff85;
        width: 45px;
        height: 45px;
        margin-top: -38px;
        font-size: 6px;
    }

    .e-c-base {
        fill: none;
        stroke: #B6B6B6;
        stroke-width: 6px
    }

    .e-c-progress-days, .e-c-progress-hours, .e-c-progress-minutes, .e-c-progress-seconds {
        fill: none;
        stroke-width: 12px;
        transition: stroke-dashoffset 0.7s;
    }

    .display-remain-days, .display-remain-hours, .display-remain-minutes, .display-remain-seconds {
        display: block;
        font-size: 1rem;
        color: white;
        font-weight: 600;
        text-shadow: 2px 1px #202020;
    }

    .tournament-leaderboard-prize {
        font-weight: bold;
        color: #f3cb00 !important;
        text-shadow: 2px 1px #202020;
    }

    .tournament-leaderboardtitle {
        font-weight: bold;
        color: #fff;
        text-shadow: 2px 1px #202020;
        font-size: 1.15rem;
    }

        .tournament-leaderboardtitle:hover {
            font-weight: bold;
            color: #f3cb00;
            text-shadow: 2px 1px #202020;
        }

        .hide{
            display:none;
        }
    .tournament-list, .tournament-detail {
        .modal {
            .modal-content {
                color: white;
                border: solid 2px #A49057;
                border-radius: 15px;
                background: linear-gradient(to bottom, #101010 50%, #524B39);
            }
        }

        .carousel-control-prev {
            left: -10px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-image: none;
        }

        .carousel-control-next {
            right: -10px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-image: none;
        }

        .showGridView, .showListView {
            color: #fff;

            span {
                color: #fff;
            }
        }

        .showGridView.active, .showListView.active, .showGridView:hover, .showListView:hover {
            color: #f3cb00;

            span {
                color: #f3cb00;
            }
        }

        .rank-container {
            box-shadow: inset 0 3px 3px #00000040;
            background: #000;
            padding: 0 10px;
            color: #fff;
            border-radius: 25px;
            display: flex;
            align-items: center;
            position: relative;
            font-size: 8px;
            margin-bottom: 5px;
        }

        .rank-icon-container {
            margin-left: -15px;
            width: 35px;
            height: 35px;
            position: relative;
        }

        .rank-icon-container img {
            width: 35px;
            height: 35px;
            max-width: none;
        }

        .rank-icon-container img.rankdaily-icon1, .rank-icon-container img.rankdaily-icon2, .rank-icon-container img.rankdaily-icon3 {
            width: 45px;
            margin-top: -9px;
            margin-left: -12px;
            height: 45px;
        }

        .rank-icon-container img.rankdaily-icon {
            width: 35px;
            height: 35px;
        }

        .rank-icon-container .rank {
            letter-spacing: 0.05em;
            font-weight: 700;
            font-size: 25px;
            color: #fff;
            font-family: 'Poppins-BoldItalic, Poppins';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .rank-container .rank-info-container {
            display: grid;
            grid-template-columns: 1fr auto;
            align-items: center;
            width: 100%;
        }

        .rank-container p.tournament-leaderboard-point {
            color: #abaaaa;
            margin-bottom: 0px;
            font-weight: bold;
            text-transform: capitalize;
            font-size: 8px;
            margin-left: .5rem;
        }

        .ribbon-tour {
            width: 150px;
            height: 150px;
            overflow: hidden;
            position: absolute;
            transform: scale(.6);
            z-index: 1;
            margin: 0;
            min-width: auto;
        }

        .ribbon-tour::before,
        .ribbon-tour::after {
            position: absolute;
            z-index: -1;
            content: '';
            display: block;
            border: 7px solid #f1ac09;
        }

        .ribbon-tour span {
            position: absolute;
            display: block;
            width: 225px;
            height: 95px;
            padding: 60px 55px 0px 0px;
            background-color: #f1ac09;
            box-shadow: 0 5px 10px rgba(0,0,0,.1);
            color: #000;
            font: 800 18px/1 'Lato', sans-serif;
            text-shadow: 0 1px 1px rgba(0,0,0,.2);
            text-transform: uppercase;
            text-align: center;
        }
        /* top left*/
        .ribbon-top-left {
            top: -36px;
            left: -21px;
        }

        .ribbon-top-left::before,
        .ribbon-top-left::after {
            border-top-color: transparent;
            border-left-color: transparent;
        }

        .ribbon-top-left::before {
            top: 0;
            right: 28px;
        }

        .ribbon-top-left::after {
            bottom: 29px;
            left: 0;
        }

        .ribbon-top-left span {
            right: -11px;
            top: -40px;
            transform: rotate(-45deg);
        }

        .btn-arrow-left i, .btn-arrow-right i {
            background-color: #a49057;
            color: #fff;
            border-radius: 5px;
            padding: 5px;
        }

        .btn-arrow-left.disabled, .btn-arrow-right.disabled {
            opacity: .35;
            pointer-events: none;
        }

        .jmc {
            cursor: pointer;
            color: #35d136 !important;
            font-weight: bold;
            margin-bottom: 0
        }

        .jmc:hover + .hide {
            display: block;
            color: #fff;
            width: 250px;
            text-align: center;
            margin-left: auto;
            margin-right: auto;
        }

        .jmc-tooltip {
            font-weight: bold;
            color: #fff;
            background: red;
            padding: 5px;
            border-radius: 5px;
            font-size: 10px;
            z-index: 2;
            position: relative;
        }

        &.isGridView {
            .flex-grow-1 > div:first-child {
                display: flex;
            }

            .rank-container .rank-info-container {
                grid-template-columns: 1fr auto;
            }

            .outside-wrapper {
                flex: 0 0 100%;
                max-width: 100%;
                position: relative;
                width: 100%;
                padding-right: 15px;
                padding-left: 15px;
                display: flex;
                align-items: center;
            }

            .tournament-wrapper {
                flex: 0 0 41.666667%;
                max-width: 340px;
                position: relative;
                width: 100%;
                padding-right: 15px;
                padding-left: 15px;
                margin-top: 3rem;
            }

            .main-wrapper {
                border: solid 2px #a49057;
                border-radius: 15px;
                background: linear-gradient(to bottom, #101010 50%, #524b39);

                .tournament-bg {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    background-size: cover;
                    background-position: center;
                    border-bottom: solid 2px #A49057;
                    border-top-right-radius: 15px;
                    border-top-left-radius: 15px;



                    .tournament-info-wrapper {
                        flex: 0 0 100%;
                        max-width: 100%;
                        position: relative;
                        width: 100%;
                        padding-right: 15px;
                        padding-left: 15px;
                        margin-top: 0.5rem;
                        margin-bottom: 0.5rem;

                        > div:first-child {
                            text-align: center;

                            .tournament-logo {
                                filter: drop-shadow(0px 5px 9px #222);
                                width: 125px;
                                height: 125px;
                                margin-top: -60px;
                                object-fit: contain;
                            }

                            .tournament-trc {
                                position: absolute;
                                z-index: 2;
                                left: 0;
                                right: 0;
                                margin-left: auto;
                                margin-right: auto;
                                color: #bdbbbb;
                                font-size: 10px;

                                span {
                                    color: #bdbbbb;
                                }
                            }

                            .tournament-name {
                                text-shadow: 2px 1px #202020;
                                height: 35px;
                                color: white;
                                font-size: 14px;
                            }
                        }
                    }

                    .tournament-countdown-wrapper {
                        flex: 0 0 100%;
                        max-width: 100%;
                        position: relative;
                        width: 100%;
                        padding-right: 15px;
                        padding-left: 15px;
                        margin-top: 0.5rem;
                        margin-bottom: 0.5rem;
                    }
                }

                .tournament-btngroup {
                    display: none;
                    text-align: right;
                }

                .leaderboard-btngroup {
                    display: block;
                    text-align: center;

                    .btn-learn-more {
                        border-radius: 15px;
                        background: #ffce00 !important;
                        color: #000;
                        padding: 5px 15px;
                        font-weight: bold;
                        min-width: 200px;
                        border: none;
                    }

                    p > span {
                        height: 18px;
                        cursor: pointer;
                        color: #abaaaa;
                        text-decoration: underline;
                        font-weight: bold;
                        display: block;
                    }
                }

                .tournament-leaderboard {
                    margin-top: 1.5rem;
                    margin-bottom: 1.5rem;
                }
            }
        }

        &.isListView {
            .flex-shrink-0 {
                display: none;
            }

            .rank-container .rank-info-container {
                grid-template-columns: 1fr 40px;
            }

            .outside-wrapper {
                flex: 0 0 100%;
                max-width: 100%;
                position: relative;
                width: 100%;
                display: flex;
                align-items: center;
            }

            .tournament-wrapper {
                flex: 0 0 100%;
                max-width: 100%;
                position: relative;
                width: 100%;
                padding-right: 15px;
                padding-left: 15px;
                margin-top: 1rem;
                margin-bottom: 1rem;
            }

            .main-wrapper {
                border: solid 2px #a49057;
                border-radius: 15px;
                background: linear-gradient(to bottom, #101010 50%, #524b39);


                .tournament-bg {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    background-size: cover;
                    background-position: center;
                    border-bottom: solid 2px #A49057;
                    border-top-right-radius: 15px;
                    border-top-left-radius: 15px;

                    .tournament-info-wrapper {
                        flex: 0 0 50%;
                        max-width: 50%;
                        position: relative;
                        width: 100%;
                        padding-right: 15px;
                        padding-left: 15px;

                        > div:first-child {
                            display: flex;
                            align-items: center;
                            margin-left: 1.5rem;
                            gap: 5px;

                            .tournament-logo {
                                filter: drop-shadow(0px 5px 9px #222);
                                width: 100px;
                                height: 100px;
                                object-fit: contain;
                            }

                            .tournament-trc {
                                position: absolute;
                                z-index: 2;
                                height: 20px;
                                color: #bdbbbb;
                                font-size: 10px;

                                span {
                                    color: #bdbbbb;
                                }
                            }

                            .tournament-name {
                                text-shadow: 2px 1px #202020;
                                color: white;
                                font-size: 14px;
                            }
                        }
                    }

                    .tournament-countdown-wrapper {
                        flex: 0 0 25%;
                        max-width: 25%;
                        position: relative;
                        width: 100%;
                        padding-right: 15px;
                        padding-left: 15px;
                    }
                }

                .tournament-btngroup {
                    display: block;
                    flex: 0 0 25%;
                    max-width: 25%;
                    position: relative;
                    width: 100%;
                    padding-right: 15px;
                    padding-left: 15px;
                    text-align: right;

                    .btn-learn-more {
                        border-radius: 15px;
                        background: #ffce00 !important;
                        color: #000;
                        padding: 5px 15px;
                        font-weight: bold;
                        min-width: 130px;
                        border: none;
                    }
                }

                .leaderboard-btngroup {
                    display: none;
                }

                .leaderboard {
                    display: grid;
                    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
                    gap: 15px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Promotion/Tournament.vue